<script setup lang="ts">
import IOSUpdatesView from '@/components/admin/views/IOSUpdatesView.vue'
</script>

<template>
  <IOSUpdatesView />
</template>
